import React from "react";
import { ProductCard } from "@/components/ProductCard";
import { PRODUCTS } from "@/lib/products";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const Products = () => {
  useDocumentMeta({
    title: "All Antivirus Plans — Huntheal for Windows PCs",
    description:
      "Huntheal Antivirus for Windows PCs. Choose 1, 3, or 5-PC plans starting at $34.95/year. Instant delivery, PayPal checkout, 30-day money-back guarantee.",
  });

  return (
    <div data-testid="products-page" className="bg-slate-50">
      {/* Header band */}
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            Catalog · {PRODUCTS.length} product
          </div>
          <h1 className="mt-2 font-display text-4xl font-black tracking-tighter text-slate-900 sm:text-5xl">
            Huntheal Antivirus for PC.
          </h1>
          <p className="mt-3 max-w-2xl text-base text-slate-600">
            Real-time threat protection for Windows PCs. Pick the plan that fits your household or team.
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Products;
